import { client } from '../util/sdk';
import { FSPS } from '../consts';
import { POST, DELETE } from '../util/api';

const loadURL = (fspId) => `/v2/${FSPS}/${fspId}/loans/search`;
const historyURL = (fspId) => `/v2/${FSPS}/${fspId}/loans/histtrans`;
const scheduledURL = (fspId) => `/v2/${FSPS}/${fspId}/loans/schedtrans`;
const deletePalPaymentURL = (fspId, payerId, loanSchedId) =>
  `/v2/fsps/${fspId}/payers/${payerId}/palpayments/${loanSchedId}`;

export const loadByLoanNumber = async ({ fspId, loanNumber }, auth) => {
  if (!auth || !auth.id) {
    throw new Error(
      'auth or auth.id is undefined in guestLoanSearch loadByLoanNumber'
    );
  }
  const queryParams = { adminUserId: auth.id };
  const payload = {
    ownerType: 'guest',
    loanNumber:
      typeof loanNumber === 'object' && loanNumber.value !== undefined
        ? loanNumber
        : { value: loanNumber },
  };
  const result = await client.executeRequest(POST, loadURL(fspId), {
    queryParams,
    data: payload,
  });
  if (result && typeof result === 'object' && result.error) {
    throw new Error(result.error.message || 'Error loading loans by number');
  }
  return result?.payload?.loans ?? result?.loans ?? result;
};

// Search by email only (with optional limit/offset)
export const loadByEmail = async ({ fspId, email, limit, offset }, auth) => {
  if (!auth || !auth.id) {
    throw new Error(
      'auth or auth.id is undefined in guestLoanSearch loadByEmail'
    );
  }
  // Ensure email is always wrapped as { value: ... }
  const payload = {
    ownerType: 'guest',
    email:
      typeof email === 'object' && email.value !== undefined
        ? email
        : { value: email },
  };
  const queryParams = { adminUserId: auth.id };
  if (offset !== undefined) queryParams.offset = offset;
  if (limit !== undefined) queryParams.limit = limit;
  return client.executeRequest(POST, loadURL(fspId), {
    queryParams,
    data: payload,
  });
};

export const loadHistoryTransactions = async ({ fspId, loanNumber }, auth) => {
  if (!auth || !auth.id) {
    throw new Error(
      'auth or auth.id is undefined in guestLoanSearch loadHistoryTransactions'
    );
  }
  const queryParams = { adminUserId: auth.id };
  const data = { loanNumber };
  const result = await client.executeRequest(POST, historyURL(fspId), {
    queryParams,
    data,
  });
  if (result && typeof result === 'object' && result.error) {
    throw new Error(
      result.error.message || 'Error loading history transactions'
    );
  }
  return result?.payload?.transactions ?? result?.transactions ?? result;
};

export const loadScheduledTransactions = async (
  { fspId, loanNumber },
  auth
) => {
  if (!auth || !auth.id) {
    throw new Error(
      'auth or auth.id is undefined in guestLoanSearch loadScheduledTransactions'
    );
  }
  const queryParams = { adminUserId: auth.id };
  const data = { loanNumber };
  const result = await client.executeRequest(POST, scheduledURL(fspId), {
    queryParams,
    data,
  });
  if (result && typeof result === 'object' && result.error) {
    throw new Error(
      result.error.message || 'Error loading scheduled transactions'
    );
  }
  return result?.payload?.transactions ?? result?.transactions ?? result;
};

export const cancelGuestScheduledPayment = async (
  { fspId, payerId, loanSchedId },
  userId
) => {
  if (!userId) {
    throw new Error(
      'userId is undefined in guestLoanSearch cancelGuestScheduledPayment'
    );
  }
  // Only include required query parameter for DELETE, and do NOT send a body
  const queryParams = {
    userId,
  };
  const result = await client.executeRequest(
    DELETE,
    deletePalPaymentURL(fspId, payerId, loanSchedId),
    {
      queryParams,
      returnModel: { name: 'palpayment' },
    }
  );
  if (result && typeof result === 'object' && result.error) {
    throw new Error(
      result.error.message || 'Error canceling scheduled payment'
    );
  }
  return result;
};
